import closeIcon from '@/components/Icons/Modals/IconClose.vue';
import { async } from 'q';

export default{
	mounted(){
		setTimeout(() => this.modalActive = true, 300);
	},

	data(){
		return{
			id: null,
			modalActive: false,
			responseReady: false,
			success: '',
			createUserSuccess: false,
			typeSelectFlag: false,
			tempSelect: "Selecciona...",

			///////////////
			//// CREATE USER
			createUser:{
				password: "",
				newPassword: "",
				newPasswordConfirm: "",
				email: "",
				type: ""
			},
			
			options: [
				{label: 'Administrador', value: 'admin'},
				{label: 'Consejo', value: 'comun'}
			]
		}
	},

	// props: ['section'],
	
	components:{
		closeIcon,
	},

	methods:{
		closeModal(){

			this.$parent.modal_addUser = false;
			this.createUserSuccess = false;

		},
		createNewUser(scope){
			this.$validator.validateAll(scope).then((result) => {
				if(result){
		
					(async () => {
						var data = JSON.parse(JSON.stringify(this.createUser));
						data._id = this.$session.get('_id');
			
						await fetch('https://api.salonacme.com/manager/create_user', {
							method: 'POST',
							headers:{
							'Content-Type': 'application/json'
							},
							body: JSON.stringify(data)
						}).then(async response => {
							response = await response.json();
							if(response.status)
							{
								this.createUserSuccess = true;
								this.$parent.get_users();
								this.createUser = {
									password: "",
									newPassword: "",
									newPasswordConfirm: "",
									email: "",
									type: ""
								};
							}else{
							alert(response.msg);
							}
						})
						.catch(error => alert(error));
					})();
		
				}
			});

		}
	}
}